const courseSlugToTitle: Record<string, string> = {
  trigonometry: 'Trigonometry Tutor Sessions',
  geometry: 'Free Geometry Tutoring and Help Online | Schoolhouse',
  sat: 'Free SAT Prep Courses | Schoolhouse',
  calculus: 'Calculus Tutor | Online Tutoring Sessions',
  statistics: 'Free Statistics Help and Tutoring Online | Schoolhouse',
  'pre-calculus': 'Precalc Tutoring Sessions Online | Precalculus Tutors',
  algebra: 'Free Algebra 1 Tutoring Online',
  algebra2: 'Free Algebra 2 Tutoring Online',
}

export default function getCoursePageTitle({
  courseSlug,
  courseName,
}: {
  courseSlug: string | null
  courseName: string | null
}): string {
  if (courseSlug == null || courseName == null) {
    return 'All Courses | Free Tutoring Sessions'
  }
  if (courseSlug in courseSlugToTitle) {
    return courseSlugToTitle[courseSlug]
  }
  return `${courseName} Tutoring | Free Tutoring Sessions`
}
